import IconClothing from './IconClothing';
import IconBag from './IconBag';
import IconShoe from './IconShoe';

/**
 * Maps the `iconName` field on a category (see `configCategories.js`)
 * to its React component. Unknown names return `null` so the
 * CategoryMenu just renders the label without an icon — no missing
 * file errors, no broken-image glyphs.
 *
 * Adding a new icon:
 *   1. Drop a new IconX.js into this folder (16×16 viewBox, single
 *      <path>, no width/height attributes — CSS controls the size).
 *   2. Import it here and add the `iconName: Component` entry below.
 *   3. Reference the `iconName` value on the relevant category in
 *      `src/config/configCategories.js`.
 */
const CATEGORY_ICONS = {
  clothing: IconClothing,
  bag: IconBag,
  shoe: IconShoe,
};

export const getCategoryIcon = name => CATEGORY_ICONS[name] || null;
